export default __webpack_public_path__ + "static/app3-d5c4856f2512bd6cc3be0699c26a14a0.jpg";